import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "level mb-3" }
const _hoisted_2 = { class: "level-left is-flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-arrow-left is-size-4 is-line-height-4" }, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "has-text-weight-semibold is-size-4" }
const _hoisted_5 = { class: "level-right" }
const _hoisted_6 = { class: "level-item is-hidden-touch" }
const _hoisted_7 = { class: "level-item is-hidden-touch" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-chevron-left is-size-4 is-line-height-4" }, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-card-outline" }, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-chevron-right is-size-4 is-line-height-4" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "level-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_ellipsis = _resolveComponent("n-ellipsis")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_dropdown = _resolveComponent("n-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
        size: "large",
        class: "mr-3",
        round: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_ellipsis, { style: {"width":"100%"} }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.station?.name), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_n_date_picker, {
          value: _ctx.timerange,
          "onUpdate:value": [
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timerange) = $event)),
            _ctx.setMonthRange
          ],
          type: "daterange",
          "month-format": "MMMM",
          shortcuts: _ctx.shortcuts,
          onIsDateDisabled: _ctx.isRangeDateDisabled
        }, null, 8 /* PROPS */, ["value", "shortcuts", "onIsDateDisabled", "onUpdate:value"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.next)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'station-details', params: { group: _ctx.group?.name , station: _ctx.previous?.id}}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, { size: "large" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]))
          : _createCommentVNode("v-if", true),
        (_ctx.station && _ctx.stations)
          ? (_openBlock(), _createBlock(_component_n_dropdown, {
              key: 1,
              trigger: "click",
              value: _ctx.station.id,
              options: _ctx.options,
              size: "large",
              onSelect: _ctx.selectDevice,
              "render-label": _ctx.renderLabel,
              checkable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, { size: "large" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["value", "options", "onSelect", "render-label"]))
          : _createCommentVNode("v-if", true),
        (_ctx.previous)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              to: { name: 'station-details', params: { group: _ctx.group?.name , station: _ctx.next?.id}}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_n_button, { size: "large" }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_n_button, {
          class: "mr-1",
          tertiary: "",
          round: "",
          size: "large",
          onClick: _ctx.refresh
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass([{spin: _ctx.loading}, "mdi mdi-refresh"])
            }, null, 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ])
    ])
  ]))
}